import React, { Component } from 'react';
import * as utils from '../../../../../../utils';
import * as Features from '../../../../../../utils/Features';
import './FullscreenSwitch.css';
import { ASSETS_FOLDER } from '../../../../../../constants';
import { trackEvent } from '../../../../../../utils/Stats';

class FullscreenSwitch extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    utils.fsSwitch();
    trackEvent('btn', 'fullscreen');
  }

  render() {
    return (
      <button
        id="fs-switch"
        className={Features.features.mobile ? '' : 'desktop'}
        onClick={this.handleClick}
      >
        <img src={`${ASSETS_FOLDER}img/ico/fullscreen.png`} alt="" />
      </button>
    );
  }
}

export default FullscreenSwitch;



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneUI/FullscreenSwitch/FullscreenSwitch.js